import { Dialog } from "primereact/dialog";
import fileUploadIcon from "../../../../../assets/upload-file.svg";
import CustomeButton from "~/components/Button";
import { FileUpload } from "primereact/fileupload";
import TaskAttachmentList from "../../TaskAttachmentList";
import FileInfo from "./FileInfo";
import PropTypes from "prop-types";
import { useEffect } from "react";

type UploadedFile = {
  file: File;
  error: object;
};
const PayslipUploadFileModal = ({
  visible,
  closeModal,
  uploadPaylispFiles,
  payslipFiles,
  setPayslipFiles,
  isLoading,
  setIsLoading,
  isPayslipFile,
  fileSupported,
  getFileSizeMB,
  openSuccessModal,
  tryAgainHandler,
  isPayslipProcessingDone,
  fileType,
}) => {
  useEffect(() => {
    if (isPayslipProcessingDone) {
      openSuccessModal();
    }
  }, [isPayslipProcessingDone]);

  const onFileUpload = (e: { files: File[] }) => {
    if (fileType === "multiple") {
      const totalFiles = payslipFiles.length + e.files.length;
      if (totalFiles > 20) {
        const allowedCount = 20 - payslipFiles.length;
        e.files = e.files.slice(0, allowedCount);
      }
    }
    const uniqueFiles = Array.from(e.files).filter(
      (eventFile) =>
        !payslipFiles.some(
          (f: UploadedFile) =>
            f.file.name === eventFile.name &&
            f.file.size === eventFile.size &&
            f.file.lastModified === eventFile.lastModified,
        ),
    );
    const validatedFiles: UploadedFile[] = uniqueFiles.map((file) => {
      let error = {};
      if (
        !fileSupported.includes(
          (file.name.split(".").pop() || "").toLocaleLowerCase(),
        )
      ) {
        error = {
          summary: "Unsupported File.",
          detail:
            "This file type is not supported. Please upload a valid file format",
        };
      } else if (+getFileSizeMB(file) > 20) {
        error = {
          summary: "File Exceeds Size Limit.",
          detail:
            "This file exceeds the maximum size limit. Please upload a smaller file",
        };
      }
      return {
        file,
        error,
      };
    });
    setPayslipFiles((prev) => [...prev, ...validatedFiles]);
  };

  const onFileRemove = (fileToRemove: UploadedFile) => {
    setPayslipFiles((prevFiles: UploadedFile[]) =>
      prevFiles.filter((file) => file !== fileToRemove),
    );
  };

  const fileUploadHandler = async () => {
    setIsLoading(true);
    await uploadPaylispFiles(payslipFiles, fileType);
  };

  const hasErrors = () => {
    return payslipFiles.some(
      (file: UploadedFile) => file.error && Object.keys(file.error).length > 0,
    );
  };
  return (
    <Dialog
      visible={visible}
      onHide={closeModal}
      style={{ width: "60vw" }}
      draggable={false}
      className="payslip-file-upload"
    >
      <div className="header flex justify-content-between">
        <p className="title">Upload Files</p>
        <i
          className="pi pi-times cross-icon mr-0"
          onClick={closeModal}
          style={{ cursor: "pointer" }}
        />
      </div>
      <div className="content flex flex-column gap-3">
        {/* add file section*/}
        <div className="file-section">
          {fileType === "multiple" && payslipFiles.length > 0 && (
            <FileUpload
              name="files"
              customUpload={true}
              onSelect={onFileUpload}
              chooseOptions={{
                icon: "pi pi-upload",
                label: "Add Files",
                iconOnly: false,
                className: "select-file-btn",
              }}
              mode="advanced"
              multiple={fileType === "multiple"}
              disabled={isLoading || payslipFiles.length >= 20}
            />
          )}
          {payslipFiles.length < 1 ? (
            <div className="file-upload-section">
              <img src={fileUploadIcon} alt="file-upload" />
              <FileUpload
                name="files"
                customUpload={true}
                onSelect={onFileUpload}
                chooseOptions={{
                  icon: "pi pi-upload",
                  label: fileType === "multiple" ? "Add Files" : "Add File",
                  iconOnly: false,
                  className: "select-file-btn",
                }}
                mode="advanced"
                multiple={fileType === "multiple"}
              />
            </div>
          ) : (
            <>
              <FileInfo fileType={fileType} />
              <TaskAttachmentList
                files={payslipFiles}
                onFileRemove={onFileRemove}
                isLoading={isLoading}
                isPayslipFile={isPayslipFile}
                tryAgainHandler={tryAgainHandler}
              />
            </>
          )}
        </div>
        {/* file type text */}
        {payslipFiles.length < 1 && <FileInfo fileType={fileType} />}

        {/* footer action buttons */}
        <div className="action-buttons">
          <CustomeButton
            label="Cancel"
            variant="outlined"
            onClick={closeModal}
          />
          <CustomeButton
            label="Upload File"
            variant="contained"
            className="upload-btn"
            onClick={fileUploadHandler}
            loading={isLoading}
            disabled={isLoading || hasErrors() || payslipFiles.length < 1}
          />
        </div>
      </div>
    </Dialog>
  );
};

PayslipUploadFileModal.propTypes = {
  visible: PropTypes.bool,
  closeModal: PropTypes.func,
  uploadPaylispFiles: PropTypes.func,
  payslipFiles: PropTypes.array,
  setPayslipFiles: PropTypes.func,
  isLoading: PropTypes.bool,
  setIsLoading: PropTypes.func,
  isPayslipFile: PropTypes.bool,
  fileSupported: PropTypes.array,
  getFileSizeMB: PropTypes.func,
  openSuccessModal: PropTypes.func,
  tryAgainHandler: PropTypes.func,
  isPayslipProcessingDone: PropTypes.bool,
  fileType: PropTypes.string,
};
export default PayslipUploadFileModal;
